if (localStorage.getItem('theme') === 'dark') {
  document.documentElement.classList.add('dark')
}
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import PrimeVue from "primevue/config";
import Aura from "@primeuix/themes/aura";
import ConfirmationService from "primevue/confirmationservice";
import ToastService from "primevue/toastservice";
import Tooltip from "primevue/tooltip";
import { attachAxiosAuth } from "./utils/axiosAuthInterceptors";
import { apiBaseURL } from "./config/apiBase";
import "primeicons/primeicons.css";
import "./style.css";

// Configure axios (paths like /api/... are relative to this origin)
axios.defaults.baseURL = apiBaseURL;
axios.defaults.headers.common["Content-Type"] = "application/json";

// Same auth + 401 logout behavior for raw `axios` (many views import axios directly)
attachAxiosAuth(axios);

const app = createApp(App);
app.use(store);
app.use(router);

if (store.getters.isAuthenticated) {
  store.dispatch("startConfigurationSettingsPolling");
}

app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      prefix: "p",
      darkModeSelector: ".dark" ,  // ✅ THIS disables dark mode
      cssLayer: false,
    },
  },
});
app.use(ConfirmationService);
app.use(ToastService);
app.directive("tooltip", Tooltip);
app.mount("#app");
